/**
 * Parse multilingual JSON string
 * Handles: JSON string → object, already-parsed object → passthrough, plain string → null
 */
export function parseMultilingualData<T = any>(data: string | object | null | undefined): T | null {
  if (!data) return null;
  if (typeof data === 'object') return data as T;

  try {
    const parsed = JSON.parse(data);
    // Only return if it parsed to an object, not a primitive
    if (parsed !== null && typeof parsed === 'object') {
      return parsed as T;
    }
    return null;
  } catch {
    // Plain string — not a multilingual JSON field, caller should use raw value
    return null;
  }
}

/**
 * Stringify multilingual data
 */
export function stringifyMultilingualData<T = any>(data: T): string {
  return JSON.stringify(data);
}

/**
 * Get value for a specific language from multilingual object
 */
export function getMultilingualValue(
  data: Record<string, string> | null | undefined,
  language: string,
  fallbackLanguage = 'en'
): string {
  if (!data) return '';
  
  return data[language] || data[fallbackLanguage] || Object.values(data)[0] || '';
}